import { render, staticRenderFns } from "./UgTableMenuButton.vue?vue&type=template&id=3d5822d6&scoped=true"
import script from "./UgTableMenuButton.vue?vue&type=script&lang=ts"
export * from "./UgTableMenuButton.vue?vue&type=script&lang=ts"
import style0 from "./UgTableMenuButton.vue?vue&type=style&index=0&id=3d5822d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5822d6",
  null
  
)

export default component.exports